<div class="form_sections form_details">
    <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Cover Limit
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row form-group">
            <div class="col-md-4"><label>Cover Limit (per annum)</label></div>
            <div class="col-md-6">
        <input type="text" class="form-control form-control-sm" 
               [value]="getCoverLimitName(quote.sdtk_option_id)" 
               readonly 
               style="background-color: #e8f5e9;">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-4"><label>Do you have any items valued at £1500 or over?</label></div>
            <div class="col-md-6">
                <label class="switch switch-left-right">
                    <input class="switch-input" type="checkbox" disabled name="has_items_over_1500"
                        [checked]="quote.sdtk_questions.has_items_over_1500 == 1" />
                    <span class="switch-label" data-on="Yes" data-off="No"></span>
                    <span class="switch-handle"></span>
                </label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-4"><label>Is the policyholder the legal owner of the saddlery and tack?</label></div>
            <div class="col-md-6">
                <label class="switch switch-left-right">
                    <input class="switch-input" type="checkbox" disabled name="is_legal_owner"
                        [checked]="quote.sdtk_questions.is_legal_owner == 1" />
                    <span class="switch-label" data-on="Yes" data-off="No"></span>
                    <span class="switch-handle"></span>
                </label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-4"><label>Where is the saddlery and tack usually stored?</label></div>
            <div class="col-md-6">
                <input type="text" value="{{building_name}}" class="form-control form-control-sm" readonly>
            </div>
        </div>


        <div class="row text-white">
            <div class="col-md-12 mb-3">
                <mat-checkbox [checked]="quote.sdtk_questions.confirm_security_requirements == 1"
                    formControlName="agree_security" name="agree_security">
                    You acknowledge and agree to comply with the Motor Vehicle Security Requirements and the Building
                    Security
                    Requirements as detailed in Section 5 of the Policy Wording.
                </mat-checkbox>
            </div>

            <div class="col-md-12 mb-3">
                <mat-checkbox [checked]="quote.sdtk_questions.confirm_non_ownership_claim_terms == 1"
                    formControlName="agree_owner_payment" name="agree_owner_payment">
                    You understand that if you are not the legal owner of the saddlery & tack then in the event of a
                    claim we will
                    require the owner's details and any settlement will be made to them.
                </mat-checkbox>
            </div>

            <div class="col-md-12 mb-3">
                <mat-checkbox [checked]="quote.sdtk_questions.confirm_not_used_for_hiring == 1"
                    formControlName="agree_no_riding_establishment" name="agree_no_riding_establishment">
                    You agree that the insured saddlery & tack is not used in connection with a riding establishment or
                    the hiring
                    out of a horse.
                </mat-checkbox>
            </div>

            <div class="col-md-12 mb-3">
                <mat-checkbox [checked]="quote.sdtk_questions.confirm_under_insurance_clause == 1"
                    formControlName="agree_under_insurance" name="agree_under_insurance" required>
                    You acknowledge and understand the Under Insurance clause as detailed in Section 5 of the Policy
                    Wording.
                </mat-checkbox>
            </div>
        </div>
    </mat-expansion-panel>
</div>
<mat-accordion>
    <div class="form_sections" *ngFor="let v of quote.vehicles; let i = index">
        <mat-expansion-panel [expanded]="i == 0">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>
                        <u>
                            <span>Item {{i + 1}}</span>
                        </u>
                    </h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col-md-10">
                    <!-- <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                        <div class="col-md-8">
                            <input type="text" name="registration_number" [value]="v.registration_number"
                                class="form-control form-control-sm" readonly>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Model</label></div>
                        <div class="col-md-8">
                            <input type="text" name="model" [value]="v.model" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Make</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.make" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Type</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.type" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Colour</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.colour" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Size</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.size" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Value</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.value" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </div>
</mat-accordion>